module.exports = __webpack_public_path__ + "img/chevron-double-up.887444d2.svg";